// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"Yn-z","slideIn":"Zn-z"};